import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    selector: '[filterButtonEvaluationColor]',
    standalone: false
})
export class FilterButtonEvaluationColorDirective {

  private readonly valuedColor = '#ff463c'
  private readonly emptyColor = ''

  @HostBinding('style.background-color') color = this.emptyColor

  @Input() set isFilterValued(isEvaluated: boolean) {
    if (isEvaluated) this.color = this.valuedColor
    else this.color = this.emptyColor
  }

}
